import { QueryStringInput } from '@hello-aria/query-string'
import { isNil } from 'lodash'
import { RedirectionGateway } from '../../../shared/models/redirectionModels'
import { RequestResponse, requestService } from '../../../shared/services/requestServices'
import { batchFetch, resolveApiUrl } from '../../../shared/utils/requestsUtils'
import { handleHttpError } from '@/shared/utils/queryUtils'

interface GetRedirectionsParams {
    companyId: string
    query?: QueryStringInput
    signal?: AbortSignal
}

export const listRedirectionsService = batchFetch(
    async (params: GetRedirectionsParams): Promise<RequestResponse<RedirectionGateway[]>> => {
        try {
            const url = resolveApiUrl('redirections.getAll', {
                variables: { companyId: params.companyId },
                query: {
                    ...params.query,
                    sorts: params.query?.sorts ?? [
                        {
                            path: 'createdAt',
                            direction: 'desc'
                        }
                    ]
                }
            })

            const response = await requestService<RedirectionGateway[]>(
                url,
                params.signal ? { signal: params.signal } : undefined
            )

            if (!response?.body) {
                return { ...response, body: [] }
            }

            return response
        } catch (error) {
            handleHttpError('listRedirectionsService', error)
            throw error
        }
    }
)

export const getRedirectionByIdService = async (
    companyId: string,
    redirectionId: string | undefined
): Promise<RequestResponse<RedirectionGateway> | undefined> => {
    if (isNil(redirectionId)) return

    try {
        const url = resolveApiUrl('redirections.get', { variables: { redirectionId, companyId } })
        const response = await requestService<RedirectionGateway>(url)

        return response
    } catch (error) {
        handleHttpError('getRedirectionByIdService', error)
    }
}
